module.exports = __webpack_public_path__ + "static/content_text_updates_2_dont-30c3246b92f8fe6f0267739e879ff289.png";